import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hasChartData',
  standalone: true,
})
export class HasChartDataPipe implements PipeTransform {
  transform(chartData: Record<string, number[]> | null | undefined, chartLabels: string[] | null | undefined): boolean {
    if (!chartData || !chartLabels) {
      return false;
    }

    const labelsExist = chartLabels.length > 0;
    const valuesExist = Object.values(chartData).some((values) => values?.length > 0 && values.some((value) => value > 0));

    return labelsExist && valuesExist;
  }
}